import {Component, OnInit} from "@angular/core";
import {UserService} from "../../shared/services/api_v1/user.service";
import {Router, ActivatedRoute, Params} from "@angular/router";
import "rxjs/add/operator/switchMap";

@Component({
    // moduleId: module.id,
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit{
    private new_activated = false;
    private new_password_code: string;
    private window: string = 'login';

    constructor(
        private user:UserService,
        private route: ActivatedRoute,
        private router: Router
    ){
    }

    ngOnInit(){
        this.route.queryParams.subscribe(values => {
            this.new_activated = values['activated'] || false;
            this.new_password_code = values['code'] || null;

            if(this.new_password_code){
                this.window = 'new_password';
            }
        });
    }

    toggle(window:string): void {
        this.new_activated = false;
        this.window = window;
    }
}


// WEBPACK FOOTER //
// ./src/app/front/home/home.component.ts